export default __webpack_public_path__ + "static/media/package.a00c5a72.png";